<template>
    <div
        class="relative border-[1px] rounded-2xl min-w-full p-[5px] min-h-[500px] laptop:p-[20px] !pt-[25px] border-gray-300 bg-[#FFFFFF]/50">
        <div @click="$router.go(-1)"
            class="transform lg:hover:scale-[1.05] active:scale-[0.98] duration-300 cursor-pointer absolute -top-[15px] left-[20px] w-max px-[10px] py-[3px] rounded-full flex items-center gap-[10px] border-[1px] border-[#F5B134] bg-gradient-to-r from-[#FDF9EE] to-[#F5B134]">
            <div class="filter invert w-[18px] h-[18px]">
                <img src="../../assets/images/back-arrow-icon.png" alt="Arrow Icon" class="w-full h-full">
            </div>
            <p class="font-poppins font-normal text-[14px] text-[#000]">Back</p>
        </div>
        <div v-if="!$helper.isEmpty(workOrderDetail)"
            class="p-[10px] laptop:p-[20px] mobile:border-[1px] mobile:border-gray-300 laptop:border-0 rounded-2xl flex flex-col gap-[15px] laptop:gap-[35px] laptop:shadow-[0_0_10px_0_#00000026] bg-[#fff]">
            <div class="flex items-center justify-between">
                <h1 class="text-[22px] font-days text-[#2459A8]">Claim Details</h1>
                <div class="flex items-center gap-[10px]">
                    <div class="hidden tablet:flex items-center gap-[10px]">
                        <span class="font-poppins font-normal text-[12px] text-[#333]">Status:</span>
                        <!-- <div> -->
                        <p v-if="workOrderDetail.progress_status_slug == 'open-lead'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#BA90C6]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'contractor-confirmed'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#29C6CD]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'en-route'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#125B9A]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'arrived'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#00ADEF]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'quote-submitted'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#8479E1]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'checkout'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#54B435]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'close'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#686D76]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'quote-decline'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#C768FF]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'cancellation-requested'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#E8B008]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'cancelled'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#FE5000]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else-if="workOrderDetail.progress_status_slug == 'authorized'"
                            class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-[5px] mb-0 text-white bg-[#9C9BBF]">
                            {{ workOrderDetail.progress_status_text }}</p>
                        <p v-else>{{ workOrderDetail.progress_status_text }}</p>
                        <!-- </div> -->
                    </div>
                    <div v-if="!(workOrderDetail.appointment_status > 1)" ref="dropdownWrapper">
                        <div class="relative flex">
                            <button class="hidden laptop:block focus:outline-none rounded-full p-[7px] bg-[#2459A8]"
                                @click="toggleDropdown">
                                <img src="../../assets/images/white-ellipse-icon.svg" alt="Up Down Arrow"
                                    class="w-[15px] h-[15px]">
                            </button>
                            <button class="laptop:hidden focus:outline-none" @click="toggleDropdown">
                                <img src="../../assets/images/white-ellipse.svg" alt="Up Down Arrow"
                                    class="w-[32px] h-[32px]">
                            </button>
                            <ul v-if="isOpen"
                                class="absolute top-[35px] right-0 z-10 mt-1 w-[200px] bg-white rounded shadow-lg text-[#333333] text-[15px] font-poppins py-[5px] overflow-hidden">
                                <li v-for="option in getActions()" :key="option" @click="select(option)"
                                    class="px-2 py-[5px] mx-[10px] my-[2px] rounded-md border-[1px] border-[#E5D3B7] bg-[#E5D3B7]/20 cursor-pointer text-left">
                                    {{ option }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tablet:hidden flex justify-end">
                <div class="flex items-center gap-[10px] rounded-full w-max p-[5px] bg-[#EFEFEF]/50">
                    <span class="font-poppins font-normal text-[12px] text-[#333]">Status:</span>
                    <p v-if="workOrderDetail.progress_status_slug == 'open-lead'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#BA90C6]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'contractor-confirmed'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#29C6CD]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'en-route'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#125B9A]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'arrived'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#00ADEF]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'quote-submitted'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#8479E1]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'checkout'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#54B435]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'close'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#686D76]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'quote-decline'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#C768FF]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'cancellation-requested'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#E8B008]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'cancelled'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#FE5000]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else-if="workOrderDetail.progress_status_slug == 'authorized'"
                        class="inline-block text-center py-[2px] px-[10px] text-[12px] font-poppins rounded-full mb-0 text-white bg-[#9C9BBF]">
                        {{ workOrderDetail.progress_status_text }}</p>
                    <p v-else>{{ workOrderDetail.progress_status_text }}</p>
                </div>
            </div>

            <div
                class="laptop:flex laptop:items-center laptop:gap-[20px] mobile:grid largeDesktop:grid mobile:grid-cols-1 tablet:grid-cols-2 largeDesktop:grid-cols-4 mobile:gap-[15px] largeDesktop:gap-[10px] largeDesktop:items-end">
                <div class="laptop:w-[23%] largeDesktop:w-auto pl-[10px] border-l-2 border-[#2459A8]">
                    <h6 class="font-poppins font-normal text-[14px] largeDesktop:text-[16px] text-[#F5B134]">Customer
                        Full
                        Name</h6>
                    <h4 class="font-days font-normal text-[20px] largeDesktop:text-[24px] text-[#333]">{{
                        workOrderDetail.consumer_name
                    }}
                    </h4>
                </div>
                <div class="laptop:w-[23%] largeDesktop:w-auto pl-[5px] laptop:pl-[10px] border-l border-[#F5B134]">
                    <h6 class="font-poppins font-normal text-[14px] text-[#999999]">Primary Number</h6>
                    <h4 class="font-poppins font-normal text-[16px] text-[#2459A8]">
                        <a v-if="!$helper.isEmpty(workOrderDetail.consumer_phone)"
                            :href="`tel:${$helper.extractPhoneNumber(workOrderDetail.consumer_phone)}`">{{
                                workOrderDetail.consumer_phone
                            }}</a>
                        <p v-else>-</p>
                    </h4>
                </div>
                <div class="mobile:order-first laptop:order-none laptop:flex justify-end">
                    <a :href="`tel:${$helper.extractPhoneNumber(workOrderDetail.helpline_number)}`"
                        :class="workOrderDetail.helpline_number?.length > 0 ? 'cursor-pointer' : 'cursor-default'"
                        class="flex items-center justify-between laptop:w-max gap-[15px] px-[10px] laptop:px-[15px] py-[7px] laptop:py-[5px] rounded-full shadow-[0_0_10px_0_#00000026]">
                        <div v-if="!$helper.isEmpty(workOrderDetail.helpline_number)"
                            class="cursor-pointer flex items-center gap-[10px] laptop:block">
                            <h6 class="mb-[3px] font-poppins font-normal text-[12px] laptop:text-[14px] text-[#F5B134]">
                                Helpline<span class="laptop:hidden">:</span></h6>
                            <h4
                                class="font-poppins font-bold text-[10px] laptop:text-[12px] laptop:min-h-[15px] text-[#2459A8]">
                                {{ $helper.isEmpty(workOrderDetail.helpline_number) ? '-' :
                                    workOrderDetail.helpline_number }}</h4>
                        </div>
                        <p v-else>-</p>
                        <img src="../../assets/images/tilt-arrow.svg" alt="Arrow Icon" class="w-[14px] h-[14px]">
                    </a>
                </div>
                <a :href="`mailto:${workOrderDetail.support_email}`"
                    class="mobile:order-first laptop:order-none flex items-center !justify-between gap-[10px] px-[10px] laptop:px-[15px] py-[7px] laptop:py-[5px] rounded-full shadow-[0_0_10px_0_#00000026]"
                    :class="workOrderDetail.support_email?.length > 0 ? 'cursor-pointer' : 'cursor-default'">
                    <div class="flex items-center gap-[5px] laptop:gap-[10px] laptop:block w-max laptop:w-auto">
                        <h6 class="mb-[3px] font-poppins font-normal text-[12px] laptop:text-[14px] text-[#F5B134]">
                            Support
                            Email<span class="laptop:hidden">:</span></h6>
                        <h4
                            class="font-poppins font-bold text-[10px] laptop:text-[12px] laptop:min-h-[15px] text-[#2459A8]">
                            {{ $helper.isEmpty(workOrderDetail.support_email) ? '-' :
                                workOrderDetail.support_email }}
                            <!-- support@myhappyhome.com -->
                        </h4>
                    </div>
                    <img src="../../assets/images/tilt-arrow.svg" alt="Arrow Icon" class="w-[14px] h-[14px]">
                </a>
            </div>

            <div
                class="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 gap-[10px] laptop:gap-[10px] largeDesktop:gap-[10px] items-stretch">
                <div
                    class="flex items-center gap-[10px] laptop:gap-[5px] largeDesktop:gap-[15px] p-[10px] largeDesktop:p-[15px] rounded-[10px] shadow-[0_0_10px_0_#00000026]">
                    <div class="p-[5px] rounded-full shadow-[0_0_10px_0_#00000026]">
                        <img src="../../assets/images/call-icon-yellow.svg" alt="Arrow Icon"
                            class="min-w-[20px] min-h-[20px]">
                    </div>
                    <div class="flex flex-col gap-[5px]">
                        <h6 class="font-poppins font-normal text-[14px] text-[#999999]">Secondary Number</h6>
                        <h4
                            class="font-poppins font-normal text-[14px] largeDesktop:text-[16px] laptop:min-h-[20px] text-[#000000]">
                            <a v-if="!$helper.isEmpty(workOrderDetail.secondary_number)"
                                :href="`tel:${$helper.extractPhoneNumber(workOrderDetail.secondary_number)}`">{{
                                    $helper.isEmpty(workOrderDetail.secondary_number) ? '-' :
                                        workOrderDetail.secondary_number }}</a>
                            <p v-else>-</p>
                        </h4>
                    </div>
                </div>
                <div
                    class="flex items-center gap-[10px] laptop:gap-[5px] largeDesktop:gap-[15px] p-[10px] largeDesktop:p-[15px] rounded-[10px] shadow-[0_0_10px_0_#00000026]">
                    <div class="p-[8px] rounded-full shadow-[0_0_10px_0_#00000026]">
                        <img src="../../assets/images/mail-icon-yellow.svg" alt="Arrow Icon"
                            class="min-w-[16px] min-h-[16px]">
                    </div>
                    <div class="flex flex-col gap-[5px]">
                        <h6 class="font-poppins font-normal text-[14px] text-[#999999]">
                            Customer Email
                        </h6>

                        <div class="relative group">
                            <h4 class="font-poppins font-normal text-[14px] largeDesktop:text-[16px]
             text-[#000000] cursor-pointer
             laptop:max-w-[320px]">
                                <a :href="`mailto:${workOrderDetail.consumer_email}`" class="block">
                                    <!-- Mobile / Tablet -->
                                    <span class="laptop:hidden">
                                        {{ workOrderDetail.consumer_email }}
                                    </span>

                                    <!-- Laptop & up -->
                                    <span class="hidden laptop:inline">
                                        {{ truncatedEmail }}
                                    </span>
                                </a>
                            </h4>

                            <!-- Tooltip (Laptop & up only) -->
                            <div v-if="isEmailTruncated" class="hidden laptop:block absolute left-0 top-full mt-1
             w-max max-w-[360px]
             bg-[#2459A8] text-white text-[13px]
             px-3 py-2 rounded-[8px]
             shadow-[0_0_10px_0_#00000026]
             opacity-0 group-hover:!opacity-100
             transition-opacity duration-200
             pointer-events-none z-50">
                                {{ workOrderDetail.consumer_email }}
                            </div>
                        </div>
                    </div>

                </div>
                <div
                    class="px-[15px] py-[7px] laptop:p-[10px] largeDesktop:p-[15px] rounded-[10px] shadow-[0_0_10px_0_#00000026] bg-[#2459A8]">
                    <div>
                        <h6 class="font-poppins font-normal text-[16px] text-[#fff]">Max Claim Amount</h6>
                        <h4 class="font-poppins font-bold text-[22px] largeDesktop:text-[30px] text-[#fff]">
                            ${{ $helper.formatAmountMode(workOrderDetail.max_claim_amount, 1) }}.<span
                                class="font-poppins font-bold text-[16px] largeDesktop:text-[20px] text-[#fff]">{{
                                    $helper.formatAmountMode(workOrderDetail.max_claim_amount, 2) }}</span></h4>
                    </div>
                </div>
                <div
                    class="px-[15px] py-[7px] laptop:p-[10px] largeDesktop:p-[15px] rounded-[10px] shadow-[0_0_10px_0_#00000026] bg-[#F5B134]">
                    <div>
                        <h6 class="font-poppins font-normal text-[16px] text-[#fff]">Out Of Pocket Amount</h6>
                        <h4 class="font-poppins font-bold text-[22px] largeDesktop:text-[30px] text-[#fff]">
                            ${{ $helper.formatAmountMode(workOrderDetail.quote_amount, 1) }}.<span
                                class="font-poppins font-bold text-[16px] largeDesktop:text-[20px] text-[#fff]">{{
                                    $helper.formatAmountMode(workOrderDetail.quote_amount, 2) }}</span></h4>
                    </div>
                </div>
            </div>

            <div
                class="grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-4 gap-[10px] laptop:gap-[10px] largeDesktop:gap-[10px]">
                <div
                    class="flex items-center gap-[5px] largeDesktop:gap-[10px] px-[10px] py-[5px] rounded-full border-[1px] border-[#2359A8]/10 bg-[#fff]">
                    <div class="p-[5px] rounded-full shadow-[0_0_10px_0_#00000026]">
                        <img src="../../assets/images/calendar-icon.png" alt="Arrow Icon" class="w-[20px] h-[20px]">
                    </div>
                    <div class="flex flex-col gap-[5px]">
                        <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#F5B134]">Claim
                            Requested</h6>
                        <h4 class="font-poppins font-normal text-[13px] largeDesktop:text-[14px] text-[#000]">{{
                            $helper.formatDateTime(workOrderDetail.created_at) }}</h4>
                    </div>
                </div>
                <div
                    class="flex items-center gap-[5px] largeDesktop:gap-[10px] px-[10px] py-[5px] rounded-full border-[1px] border-[#2359A8]/10 bg-[#fff]">
                    <div class="p-[5px] rounded-full shadow-[0_0_10px_0_#00000026]">
                        <img src="../../assets/images/calendar-icon.png" alt="Arrow Icon" class="w-[20px] h-[20px]">
                    </div>
                    <div class="flex flex-col gap-[5px]">
                        <div class="flex items-center justify-between gap-[30px]">
                            <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#F5B134]">Visit
                                Date
                                &
                                Time</h6>
                            <div v-if="workOrderDetail?.can_reschedule == '1'" @click="updateDateTime"
                                class="group rounded-full shadow-[0_0_10px_0_#00000026] w-max cursor-pointer">
                                <img src="../../assets/images/edit-icon.svg" alt="Arrow Icon"
                                    class="w-[26px] h-[26px] group-hover:hidden">
                                <img src="../../assets/images/edit-hover-icon.svg" alt="Arrow Icon"
                                    class="w-[26px] h-[26px] hidden group-hover:block">
                            </div>
                        </div>
                        <h4 class="font-poppins font-normal text-[13px] largeDesktop:text-[14px] text-[#000]">{{
                            $helper.formatDateTime(workOrderDetail.appointment_date) }}</h4>
                    </div>
                </div>
                <div
                    class=" flex items-center gap-[5px] largeDesktop:gap-[10px] px-[10px] py-[5px] rounded-full border-[1px] border-[#2359A8]/10 bg-[#fff]">
                    <div class="p-[5px] rounded-full shadow-[0_0_10px_0_#00000026]">
                        <img src="../../assets/images/technician-icon-blue.svg" alt="Arrow Icon"
                            class="min-w-[20px] min-h-[20px]">
                    </div>
                    <div class="flex flex-col gap-[5px]">
                        <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#F5B134]">Technician
                        </h6>
                        <div class="relative group">
                            <h4 class="font-poppins font-normal text-[13px] largeDesktop:text-[14px] text-[#000]">
                                <!-- Mobile / Tablet -->
                                <span class="laptop:hidden">
                                    {{ workOrderDetail.assignee_name }}
                                </span>

                                <!-- Laptop & up -->
                                <span class="hidden laptop:inline">
                                    {{ truncatedTechnicianName }}
                                </span>
                            </h4>

                            <!-- Tooltip (Laptop & up only) -->
                            <div v-if="isTechnicianNameTruncated" class="hidden laptop:block absolute left-0 top-full mt-1
             w-max max-w-[360px]
             bg-[#2459A8] text-white text-[13px]
             px-3 py-2 rounded-[8px]
             shadow-[0_0_10px_0_#00000026]
             opacity-0 group-hover:!opacity-100
             transition-opacity duration-200
             pointer-events-none z-50">
                                {{ workOrderDetail.assignee_name }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-2 laptop:grid-cols-4 gap-[10px] laptop:gap-[10px] largeDesktop:gap-[20px]">
                <div class="flex flex-col gap-[3px] pb-[5px] laptop:pb-[10px] border-b-[3px] border-[#2459A8]">
                    <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#999]">Job ID</h6>
                    <h4 class="font-poppins font-normal text-[14px] largeDesktop:text-[16px] text-[#000]">{{
                        workOrderDetail.job_number
                        }}</h4>
                </div>
                <div class="flex flex-col gap-[3px] pb-[5px] laptop:pb-[10px] border-b-[3px] border-[#2459A8]">
                    <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#999]">Agreement ID</h6>
                    <h4 class="font-poppins font-normal text-[14px] largeDesktop:text-[16px] text-[#000]">{{
                        workOrderDetail.agreement_number }}</h4>
                </div>
                <div class="flex flex-col gap-[3px] pb-[5px] laptop:pb-[10px] border-b-[3px] border-[#2459A8]">
                    <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#999]">Trade</h6>
                    <h4 class="font-poppins font-normal text-[14px] largeDesktop:text-[16px] text-[#000]">{{
                        workOrderDetail.trade_name
                        }}</h4>
                </div>
                <div class="flex flex-col gap-[3px] pb-[5px] laptop:pb-[10px] border-b-[3px] border-[#2459A8]">
                    <h6 class="font-poppins font-normal text-[13px] laptop:text-[14px] text-[#999]">Service Type</h6>
                    <h4 class="font-poppins font-normal text-[14px] largeDesktop:text-[16px] text-[#000]">{{
                        workOrderDetail.service_name
                        }}</h4>
                </div>
            </div>

            <div>
                <h6 class="mb-[8px] font-poppins font-normal text-[14px] text-[#666666]">Service Address</h6>
                <div
                    class="flex laptop:items-center gap-[10px] rounded-[10px] p-[7px] largeDesktop:p-[10px] border-[1px] border-[#F5B134]/50 bg-[#FDF9EE]">
                    <img src="../../assets/images/map-icon-yellow.svg" alt="Map Icon" class="w-[24px] h-[24px] largeDesktop:w-[30px] largeDesktop:h-[30px]">
                    <p class="font-poppins font-normal text-[14px] text-[#333]">{{ workOrderDetail.address
                        }}</p>
                </div>
            </div>
            <div>
                <h6 class="mb-[8px] font-poppins font-normal text-[14px] text-[#666666]">Issue</h6>
<div class="min-h-[100px] max-h-[200px] overflow-y-auto rounded-[10px] p-[10px] border-[1px] border-[#2459A8]/10 bg-[#EFEFEF]/50">
    <p class="font-poppins font-normal text-[13px] largeDesktop:text-[14px] text-[#333] whitespace-pre-line">
        {{ workOrderDetail.complaint_notes }}
    </p>
</div>
            </div>
        </div>
        <cancelClaimModal ref="cancelClaimModal" @cancelled="refreshList" />
        <resheduleApptModal ref="resheduleApptModal" @cancelled="refreshList" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import cancelClaimModal from "../../components/cancelClaim/cancelClaimModal.vue";
import resheduleApptModal from "../../components/cancelClaim/resheduleApptModal.vue";
export default {
    props: ["item"],
    data() {
        return {
            isOpen: false,
            appointment_id: this.$route.params.id,
            workOrderDetail: null
        };
    },
    components: {
        cancelClaimModal,
        resheduleApptModal
    },
    computed: {
        ...mapGetters([
            "workOrderDetailResponse",
        ]),
        truncatedEmail() {
            const email = this.workOrderDetail.consumer_email || '';
            return email.length > 15 ? email.slice(0, 15) + '...' : email;
        },
        isEmailTruncated() {
            return (this.workOrderDetail.consumer_email || '').length > 15;
        },
        truncatedTechnicianName() {
            const name = this.workOrderDetail.assignee_name || '';
            return name.length > 15 ? name.slice(0, 15) + '...' : name;
        },
        isTechnicianNameTruncated() {
            return (this.workOrderDetail.assignee_name || '').length > 15;
        }
    },
    watch: {
        workOrderDetailResponse: function (data) {
            this.workOrderDetail = this.workOrderDetailResponse
        },

    },
    mounted() {
        this.getWorkOrderDetail({
            "id": this.$route.params.id
        })
        document.addEventListener('click', this.handleClickOutside);
        window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    unmounted() {
        document.removeEventListener('click', this.handleClickOutside);
    },
    methods: {
        ...mapActions([
            "getWorkOrderDetail",
        ]),
        getActions() {
            let res = ["Cancel"]

            return res
        },
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        select(value) {
            if (value == "Cancel") {
                this.$refs.cancelClaimModal.show(this.appointment_id);
            }
            this.isOpen = false;
        },
        handleClickOutside(event) {
            if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
                this.isOpen = false;
            }
        },

        updateDateTime() {
            this.$refs.resheduleApptModal.show(this.workOrderDetail.appointment_id, this.workOrderDetail.appointment_date);
        },

        refreshList() {
            this.getWorkOrderDetail({
                "id": this.$route.params.id
            })
        }
    }
}
</script>